import React, {Component} from "react"
import request from "../../utils/request";
import DataTable from "react-data-table-component";
import {observer} from "mobx-react";
import patient from "../../stores/patient";
function calculateMonday(sundayDateStr) {
  // Create a Date object from the provided date string
  const sunday = new Date(sundayDateStr);

  // Calculate Monday by subtracting 6 days from Sunday
  sunday.setDate(sunday.getDate() - 6);

  // Return the date as a string in yyyy-mm-dd format
  return sunday.toISOString().split('T')[0];
}
@observer
export class WeeklySummary extends Component {
  state = {
    reports: []
  };

  componentDidMount() {
    this.fetchReports().then();
  }

  fetchReports = async () => {
    const res = await request('/api/adherenceStats/getByMedsReports', {
      patientID: patient.fields._id,
    });

    if(res.success) {
      this.setState({reports: res.data.byMedsReports});
    } else {
      console.error('fetch weekly summary reports failed');
    }
  }

  render() {
    const columns = [
      {
        name: 'Prescription',
        selector: row => row.prescription,
        sortable: true,
      },
      {
        name: 'Date Range (Week)',
        selector: row => `${calculateMonday(row.sunday_stop)} to ${row.sunday_stop}`,
        sortable: true,
      },
      {
        name: 'Start Date',
        selector: row => row.startDate,
        sortable: true,
      },
      {
        name: 'End Date',
        selector: row => row.endDate,
        sortable: true,
      },
      {
        name: 'Eye',
        selector: row => row.eye,
        sortable: true,
      },
      {
        name: 'Frequency',
        selector: row => `${row.frequency} times per day`,
        sortable: true,
      },
      {
        name: 'Adherence Rate',
        selector: row => `${(row.perc_med_adherent<=100?row.perc_med_adherent:0).toFixed(2)}%`,
        sortable: true,
      },
    ];

    return (
      <DataTable
        title="Weekly Adherence Report By Medications"
        columns={columns}
        data={this.state.reports}
        defaultSortField="startDate"
        pagination
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/AdherenceStats/WeeklySummary.jsx